import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

// v2 «asphalt» header in the CleverParking identity — dark in both themes,
// pill nav items with a gradient active state, solid divider below (NEVER
// dashed — see the no-dashed-lines rule).

export const HeaderV2 = styled.header`
  height: 62px;
  display: flex;
  align-items: center;
  gap: 26px;
  padding: 0 26px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: radial-gradient(120% 180% at 0% 0%, rgba(71, 185, 114, 0.1) 0%, transparent 42%), var(--cp-asphalt, #0c1210);

  @media (max-width: 1600px) {
    gap: 16px;
    padding: 0 18px;
  }
  @media (max-width: 1360px) {
    gap: 10px;
    padding: 0 12px;
  }
`;

export const BrandV2 = styled.div`
  display: flex;
  align-items: center;
  flex: none;
  cursor: pointer;
  a {
    display: flex;
    align-items: center;
  }
`;

export const BrandImg = styled.img`
  height: 44px;
  width: auto;
  display: block;
  @media (max-width: 1440px) {
    height: 40px;
  }
  @media (max-width: 1200px) {
    height: 34px;
  }
`;

export const LogoV2 = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #5cc98a 0%, #47b972 60%, #3aa863 100%);
  box-shadow: 0 3px 12px rgba(71, 185, 114, 0.4);
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  line-height: 1;
  flex: none;
`;

export const WordMarkV2 = styled.div`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #f2f6f3;
  white-space: nowrap;
  span {
    color: #5cc98a;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const NavStripV2 = styled.nav`
  display: flex;
  align-items: stretch;
  align-self: stretch;
  gap: 2px;
  /* centered between the brand (left) and the right-side controls */
  flex: 0 1 auto;
  margin: 0 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

/* Modern nav: no pill fill — a full-height item with a glowing green
   underline indicator under the active one (approved "Variant B"). */
export const NavItemV2 = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  padding: 0 14px;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: rgba(242, 246, 243, 0.68);
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease;
  svg {
    width: 16px;
    height: 16px;
    flex: none;
    opacity: 0.85;
  }
  &:hover {
    color: #eafff2;
  }
  &.active {
    color: #ffffff;
    font-weight: 600;
  }
  &.active svg {
    opacity: 1;
    color: var(--cp-green-bright, #5cc98a);
  }
  &.active::after {
    content: '';
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: 0;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(90deg, var(--cp-green-bright, #5cc98a), var(--cp-green, #47b972));
    box-shadow: 0 0 10px rgba(92, 201, 138, 0.6);
  }

  @media (max-width: 1600px) {
    padding: 0 12px;
    font-size: 13px;
    gap: 7px;
  }
  @media (max-width: 1360px) {
    padding: 0 10px;
    gap: 6px;
  }
  /* very narrow — icons only (labels available via title tooltip) so no nav
     item (e.g. «Настройки») gets pushed off-screen */
  @media (max-width: 1200px) {
    padding: 0 11px;
    .nav-label {
      display: none;
    }
  }
`;

export const RightV2 = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: none;
  /* the nav's auto margins already push this block to the right edge */
`;

export const UserV2 = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 10px 0 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: #f2f6f3;
  font-size: 12.5px;
  font-weight: 500;
  white-space: nowrap;
  i {
    cursor: pointer;
    margin-left: 2px;
    color: rgba(242, 246, 243, 0.6);
    transition: color 0.15s ease;
  }
  i:hover {
    color: #5cc98a;
  }
  @media (max-width: 1500px) {
    .uname {
      display: none;
    }
  }
`;

export const AvatarV2 = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #5cc98a 0%, #47b972 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex: none;
`;

// Solid divider under the header — NEVER dashed.
export const RoadLineV2 = styled.div`
  height: 2px;
  background: var(--cp-green, #47b972);
`;
